import * as React from 'react';
import { Badge } from '@mui/material';
import { fetchUnreadSummary } from './whatsappApi.js';

const POLL_MS = 20000;

// Unread customer messages waiting for me (and, for admins, in unassigned chats), shown next to
// the WhatsApp menu in the ERP sidebar. Also pops a desktop alert when a new one arrives, if the
// user allowed notifications (Live Inbox → "Turn on desktop alerts").
// ponytail: polls every 20s per open ERP tab; switch to the backend pushing over a socket if that load matters.
export function useWhatsAppUnread() {
  const [count, setCount] = React.useState(0);
  const last = React.useRef(null);

  React.useEffect(() => {
    let live = true;
    const check = async () => {
      try {
        const { mine, unassigned, latest } = await fetchUnreadSummary();
        if (!live) return;
        const total = (mine || 0) + (unassigned || 0);
        if (last.current !== null && total > last.current && latest && 'Notification' in window && Notification.permission === 'granted') {
          const n = new Notification(`WhatsApp: ${latest.name || `+${latest.phone}`}`, { body: latest.lastPreview || 'New message', tag: `wa-${latest.phone}` });
          n.onclick = () => { window.focus(); window.location.assign('/whatsapp-marketing/inbox'); };
        }
        last.current = total;
        setCount(total);
      } catch {
        // The WhatsApp service being down must not break the ERP sidebar; the badge just stays.
      }
    };
    check();
    const id = setInterval(check, POLL_MS);
    return () => { live = false; clearInterval(id); };
  }, []);

  return count;
}

export default function WhatsAppUnreadBadge({ children }) {
  const count = useWhatsAppUnread();
  return (
    <Badge color="error" badgeContent={count} max={99} sx={{ '& .MuiBadge-badge': { right: -10 } }}>
      {children}
    </Badge>
  );
}
